import { makeChartComp } from '../../util/makeChartComp';
var WaterfallChart = makeChartComp('Waterfall');
export default WaterfallChart;
